import { render, staticRenderFns } from "./TaskMenuBoard.vue?vue&type=template&id=7315b38a&"
import script from "./TaskMenuBoard.vue?vue&type=script&lang=js&"
export * from "./TaskMenuBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports